module.exports = __webpack_public_path__ + "img/aplicacao_pelicula3.7ebe6f73.jpg";